import React from 'react';
import {
  Box, Grid, Skeleton, Card,
} from '@mui/material';

const HowItWorksSectionSkeleton = () => (
  <Box>
    <Skeleton
      variant="rectangular"
      width="60%"
      height={38}
      className="HIWSSTitle"
    />
    <Grid container spacing={4} py={2}>
      {[...Array(4).keys()].map((item) => (
        <Grid item sm={12} md={6} lg={3} key={item}>
          <Card
            sx={{
              backgroundColor: 'transparent',
              border: '1px solid #AEAEAE',
              borderRadius: '5px',
            }}>
            <Box p={2}>
              <Skeleton
                variant="rectangular"
                height={130}
                sx={{ marginBottom: 2 }}
              />
              <Skeleton variant="text" height={32} />
              <Box display="flex" flexDirection="column" alignItems="center">
                <Skeleton variant="text" width="80%" height={18} />
                <Skeleton variant="text" width="60%" height={18} />
              </Box>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
    <Box mt={3}>
      <Skeleton variant="text" width="100%" height={18} />
    </Box>
  </Box>
);
export { HowItWorksSectionSkeleton };
